globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Settings = appCustomerSpace.Controllers.Settings || {};

appCustomerSpace.Controllers.Settings.BookingSettingsController = (function(superClass) {

  utils.extend(BookingSettingsController, superClass);

  function BookingSettingsController() {
    return BookingSettingsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(BookingSettingsController.prototype, {
    init: function() {
      this.initImageContentSync();

      return BookingSettingsController.__super__.init.apply(this, arguments);
    },

    initImageContentSync: function() {
      $('body').on('customer-space--image-content:updated', function(event) {
        var detail = event.originalEvent && event.originalEvent.detail;

        $(event.target).closest('form').find('.js-image-content-id').val(detail ? detail.imageContentId : '');
      });

      $('body').on('customer-space--image-content:deleted', function(event) {
        $(event.target).closest('form').find('.js-image-content-id').val('');
      });
    }
  });

  return BookingSettingsController;

})(appCustomerSpace.Controllers.Settings.MainController);
